import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService, GenesisUnitOfWork, AppInformationService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { Router } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-models-overview',
    templateUrl: './models-overview.component.html',
    styleUrls: ['./models-overview.component.scss'],
    standalone: false
})
export class ModelsOverviewComponent implements OnInit {
    models: any;
    statusList: any[];
    selectedStatuses = [];


    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.selectedStatuses = [];
        this.statusList = this.uow.lookups.orderLineStatuses;

        this.models = [];
    }

    async searchByStatus() {
        this.appInfo.pleaseWaitShow();
        this.models = await this.uow.getModelsOverview(this.selectedStatuses);
        this.appInfo.pleaseWaitHide();
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            }
        );
    }
}
